var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292120",
    cx: 5.65635,
    cy: 15.867,
    rx: 2.19871,
    ry: 3.915,
    transform: "rotate(59.8665 5.65635 15.867)",
    fill: "url(#paint0_linear_2758_22165)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292121",
    cx: 17.5733,
    cy: 9.36697,
    rx: 2.19871,
    ry: 3.915,
    transform: "rotate(59.8665 17.5733 9.36697)",
    fill: "url(#paint1_linear_2758_22165)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292119",
    cx: 11.8288,
    cy: 12.0937,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(119.993 11.8288 12.0937)",
    fill: "url(#paint2_linear_2758_22165)",
    stroke: "#DFDFDF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292122",
    cx: 11.6509,
    cy: 12.1134,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(-180 11.6509 12.1134)",
    fill: "url(#paint3_linear_2758_22165)",
    stroke: "#DFDFDF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 292118",
    cx: 11.9046,
    cy: 11.8633,
    rx: 2.90089,
    ry: 10.6366,
    transform: "rotate(59.8665 11.9046 11.8633)",
    stroke: "#DFDFDF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2758_22165",
    x1: 3.92879,
    y1: 11.952,
    x2: 10.2709,
    y2: 15.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2758_22165",
    x1: 15.8458,
    y1: 5.45197,
    x2: 22.1879,
    y2: 9.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2758_22165",
    x1: 10.8843,
    y1: 3.0604,
    x2: 22.9692,
    y2: 9.28263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2758_22165",
    x1: 9.37159,
    y1: 1.47678,
    x2: 20.0531,
    y2: 4.73951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#713D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelDarkActive);
export default __webpack_public_path__ + "static/media/channel-dark-active.2d192edd087445df3e3eac31f91c6c99.svg";
export { ForwardRef as ReactComponent };